"use client";

import { HOP_BG_COLORS, HOP_RING_COLORS } from "@/config/constants";

interface HopDotProps {
  type: string;
}

export default function HopDot({ type }: HopDotProps) {
  return (
    <div className="relative flex items-center justify-center w-6 h-6 shrink-0">
      <div
        className={`absolute w-6 h-6 rounded-full border-2 ${HOP_RING_COLORS[type as keyof typeof HOP_RING_COLORS] ?? HOP_RING_COLORS.transit} animate-pulse-ring`}
        aria-hidden="true"
      />
      <div
        className={`w-2.5 h-2.5 rounded-full ${HOP_BG_COLORS[type as keyof typeof HOP_BG_COLORS] ?? HOP_BG_COLORS.transit} z-10`}
      />
    </div>
  );
}
